var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgInfo = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  fill: "none",
  viewBox: "0 0 16 16",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M7.46 12h1.2V7.2h-1.2V12ZM8 5.72c.187 0 .343-.06.47-.18a.606.606 0 0 0 .19-.46.672.672 0 0 0-.19-.48.622.622 0 0 0-.47-.2.622.622 0 0 0-.47.2.672.672 0 0 0-.19.48c0 .187.063.34.19.46s.283.18.47.18ZM8 16a7.74 7.74 0 0 1-3.1-.63 8.114 8.114 0 0 1-2.55-1.72A8.115 8.115 0 0 1 .63 11.1 7.79 7.79 0 0 1 0 7.98c0-1.093.21-2.127.63-3.1.42-.973.993-1.82 1.72-2.54A8.2 8.2 0 0 1 4.9.63 7.79 7.79 0 0 1 8.02 0a7.74 7.74 0 0 1 3.1.63c.973.42 1.82.99 2.54 1.71s1.29 1.567 1.71 2.54c.42.973.63 2.013.63 3.12a7.74 7.74 0 0 1-.63 3.1 8.202 8.202 0 0 1-1.71 2.55 7.995 7.995 0 0 1-2.54 1.72A7.79 7.79 0 0 1 8 16Zm.02-1.2c1.88 0 3.48-.663 4.8-1.99 1.32-1.327 1.98-2.937 1.98-4.83 0-1.88-.66-3.48-1.98-4.8C11.5 1.86 9.893 1.2 8 1.2c-1.88 0-3.483.66-4.81 1.98C1.863 4.5 1.2 6.107 1.2 8c0 1.88.663 3.483 1.99 4.81 1.327 1.327 2.937 1.99 4.83 1.99Z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgInfo);
export default ForwardRef;